export const socialsData = {
    github: 'https://github.com/moel97',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://de.linkedin.com/in/mohamed-elsayed-5a7a8025b',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/',
    xing: 'https://www.xing.com/profile/Mohamed_Elsayed68/'
}